import React from "react";
import { Link } from "react-router-dom";
import LogoLight from "../assets/images/logo-light.webp";
import { MdKeyboardArrowRight } from "react-icons/md";

export default function Footer() {
  return (
    <>
      <footer className="relative bg-slate-900 dark:bg-slate-800 mt-24">
        <div className="container">
          <div className="grid grid-cols-1">
            <div className="relative py-16">
              {/* <!-- Subscribe --> */}
              <div className="relative w-full">
                <div className="relative -top-40 dark:bg-slate-900 lg:px-8 px-6 py-10 dark:shadow-gray-700 overflow-hidden">
                  <div className="grid md:grid-cols-2 grid-cols-1 items-center gap-[30px]"></div>
                </div>

                <div className="grid md:grid-cols-12 grid-cols-1 gap-[80px] -mt-24">
                  <div className="lg:col-span-3 md:col-span-12">
                    <Link to="#" className="text-[22px] focus:outline-none">
                      <img
                        src={LogoLight}
                        alt="Panoramic Mountain Group"
                        className="h-10 md:h-24 w-auto object-contain"
                        loading="lazy"
                        decoding="async"
                      />
                    </Link>
                  </div>

                  <div className="lg:col-span-2 md:col-span-4">
                    <h5 className="tracking-[1px] text-gray-100 font-semibold">
                      Company
                    </h5>
                    <ul className="list-none footer-list mt-6">
                      <li>
                        <Link
                          to="/aboutus"
                          className="text-slate-300 hover:text-slate-400 duration-500 ease-in-out flex items-center"
                        >
                          <MdKeyboardArrowRight className="me-1 text-xl" />{" "}
                          About us
                        </Link>
                      </li>
                    </ul>
                  </div>

                  <div className="lg:col-span-3 md:col-span-4">
                    <h5 className="tracking-[1px] text-gray-100 font-semibold">
                      Useful Links
                    </h5>
                    <ul className="list-none footer-list mt-6">
                      <li>
                        <Link
                          to="/terms"
                          className="text-slate-300 hover:text-slate-400 duration-500 ease-in-out flex items-center"
                        >
                          <MdKeyboardArrowRight className="me-1 text-xl" />{" "}
                          Terms of Services
                        </Link>
                      </li>
                      <li className="mt-[10px]">
                        <Link
                          to="/privacy"
                          className="text-slate-300 hover:text-slate-400 duration-500 ease-in-out flex items-center"
                        >
                          <MdKeyboardArrowRight className="me-1 text-xl" />{" "}
                          Privacy Policy
                        </Link>
                      </li>
                      <li className="mt-[10px]">
                        <Link
                          to="/contact"
                          className="text-slate-300 hover:text-slate-400 duration-500 ease-in-out flex items-center"
                        >
                          <MdKeyboardArrowRight className="me-1 text-xl" />{" "}
                          Contact
                        </Link>
                      </li>
                    </ul>
                  </div>

                  {/*  Commented out for now - Social Media Links <div className="lg:col-span-3 md:col-span-4">
                    <h5 className="tracking-[1px] text-gray-100 font-semibold">
                      Follow Us
                    </h5>
                    <div className="flex mt-6">
                      <MdNetworkPing className="size-5 text-slate-700 me-3" />
                      <div className="">
                        <h6 className="text-gray-300 mb-2">
                          Stay connected! Follow us on social media.
                        </h6>
                        <ul className="flex space-x-2">
                          <li>
                            <Link
                              to="http://linkedin.com/company/shreethemes"
                              target="_blank"
                              className="btn btn-icon btn-sm text-gray-400 hover:text-white border border-gray-800 dark:border-gray-700 rounded-md hover:border-green-600 dark:hover:border-green-600 hover:bg-slate-600 dark:hover:bg-slate-600"
                            >
                              <FiLinkedin className="size-4" />
                            </Link>
                          </li>
                          <li>
                            <Link
                              to="https://www.facebook.com/shreethemes"
                              target="_blank"
                              className="btn btn-icon btn-sm text-gray-400 hover:text-white border border-gray-800 dark:border-gray-700 rounded-md hover:border-green-600 dark:hover:border-green-600 hover:bg-slate-600 dark:hover:bg-slate-600"
                            >
                              <FiFacebook className="size-4" />
                            </Link>
                          </li>
                          <li>
                            <Link
                              to="mailto:support@shreethemes.in"
                              className="btn btn-icon btn-sm text-gray-400 hover:text-white border border-gray-800 dark:border-gray-700 rounded-md hover:border-green-600 dark:hover:border-green-600 hover:bg-slate-600 dark:hover:bg-slate-600"
                            >
                              <FiMail className="size-4" />
                            </Link>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div> */}
                </div>
              </div>
              {/* <!-- Subscribe --> */}
            </div>
          </div>
        </div>

        <div className="py-[30px] border-t border-gray-800 dark:border-gray-700">
          <div className="container">
            <div>
              <ul className="list-none text-center">
                <li className="text-white">
                  Panoramic Mountain Group & The PMG Group
                  <br></br>
                  4450 Arapahoe Avenue, Suite 100-149 Boulder, CO 80303
                  <br></br>
                  (720) 593-8234
                  <br></br>© {new Date().getFullYear()} Panoramic Mountain Group and the PMG Group
                </li>
              </ul>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
}
